"use strict" /* eslint-disable no-console */;

import _ from "lodash";

const showHideMobileCta = (function() {

  var isScrolledIntoView = function(el) {
    const scroll = window.scrollY || window.pageYOffset;
    const boundsTop = el.getBoundingClientRect().top + scroll;

    const viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight,
    };

    const bounds = {
      top: boundsTop,
      bottom: boundsTop + el.clientHeight,
    };

    return (
      (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
      (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
      );
    };

    function scrollStop() {
      const mobileCtaButton = document.querySelector(".title-hero__cta-btn") || document.createElement('div');
      const footer = document.querySelector(".main-footer") || document.createElement('div');
      const footerInView = isScrolledIntoView(footer);

      footerInView ? mobileCtaButton.classList.remove("in-hero") : mobileCtaButton.classList.add("in-hero");
  }

  function init() {
    window.addEventListener("scroll", _.debounce(() => scrollStop(), 50));
  }

  window.addEventListener("DOMContentLoaded", init);
})();

export default showHideMobileCta;



// WEBPACK FOOTER //
// ./resources/assets/js/mobile-cta.js